import { photoUrl } from "@/lib/api";
import selection from "@/data/photoSelection.json";
import { Reveal } from "@/components/Reveal";
import { Ornament } from "@/components/Ornament";

export const Story = () => (
  <section id="story" className="container-editorial pt-28 md:pt-36 pb-16 md:pb-24">
    <Ornament />
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-center">
      <Reveal className="lg:col-span-5 order-2 lg:order-1">
        <div className="eyebrow-rule">Our Story</div>
        <h2 className="editorial-heading text-3xl md:text-4xl lg:text-[44px]">
          A <em>family home,</em><br />
          shared with you.
        </h2>
        <div className="mt-10 space-y-6 text-[hsl(var(--muted-foreground))] text-[15px] leading-[1.85] max-w-lg">
          <p>
            Ata House is built on the land of our ancestors. For generations this small
            corner of Rarotonga has belonged to our family, and it is a privilege to
            share it with travellers who love the islands the way we do.
          </p>
          <p>
            We&apos;ve designed the house as a considered, comfortable home — not a hotel.
            Linen, timber, marble, soft sage gardens, the lagoon just steps away.
            A place to slow down, cook a long breakfast, swim in the pool, and let
            the days unfold gently.
          </p>
        </div>
        <div className="mt-10 flex items-center gap-4">
          <span className="block h-px w-10 bg-[hsl(var(--oak-deep))]/60" />
          <p className="font-serif-italic text-xl text-[hsl(var(--ink))]">
            AJ &amp; Brad
          </p>
        </div>
      </Reveal>

      <Reveal delay={140} className="lg:col-span-7 order-1 lg:order-2">
        <div className="relative">
          <div className="img-frame aspect-[4/5] md:aspect-[5/6]">
            <img
              src={photoUrl(selection.story)}
              alt="Rattan armchair in soft window light at Ata House"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute -left-4 md:-left-8 top-8 hidden md:block writing-vertical text-[10px] tracking-[0.5em] uppercase text-[hsl(var(--muted-foreground))]">
            Interior · Living
          </div>
          <style>{`
            .writing-vertical { writing-mode: vertical-rl; transform: rotate(180deg); }
          `}</style>
        </div>
      </Reveal>
    </div>
  </section>
);
